import styled from 'styled-components';
import { Text } from 'prospect-path-components';

const ErrorText = styled(Text)`
   color: #9c0606;
   font-weight: bold;
`;

export default ErrorText;
